import type { CancellationReasons } from '@grandvisionhq/appointments'

export const cancellationReasons: CancellationReasons[] = [
  'CANCEL_APPOINMENT_IS_NEEDED_SOONER',
  'CANCEL_APPOINTMENT_NOT_NEEED',
  'CANCEL_DOUBLE_BOOKED',
  'CANCEL_UNABLE_TO_ATTEND',
  'CANCEL_WRONG_APPOINTMENT_BOOKING',
  'CANCEL_OTHER',
]
